import LocaleContext from 'contexts/LocaleContext';
import { useContext } from 'react';

const useTranslate = () => useContext(LocaleContext)?.translate!;

export default useTranslate;
